<div
  [ngClass]="{ placeholder: isPlaceholder, 'placeholder-light': isPlaceholderLight, auto: auto, 'small-header': !showHeader, 'no-shadow': !showShadow }"
  class="report-tile">
  @if (!auto) {
    <div class="report-header">
      <span>{{ "report.item.cardTitle" | translate }} {{ !showHeader ? "- " + item.reportingPeriod : null }}</span>
    </div>
  }
  @if (showHeader) {
    <div class="report-header report-header--bottom">
      <span>{{ item?.responsible.orgDescription }}</span>
      <span>-</span>
      <span>{{ item?.responsible.orgCode }}</span>
    </div>
  }
  <div class="report-content">
    <div class="report-body">
      <circle-progress
        [percent]="item?.doc * 100"
        [radius]="auto ? 60 : 70"
        [outerStrokeWidth]="10"
        [innerStrokeWidth]="8"
        [outerStrokeColor]="outerStrokeColor"
        [innerStrokeColor]="innerStrokeColor"
        [animation]="false" />
      <div class="circle-placeholder"></div>
    </div>
    <div class="report-footer">
      <div class="card-cell" [ngClass]="{ 'card-cell--full': basic }">
        <label>{{ "report.item.dueDate" | translate }}</label>
        <span>{{ item?.dueDate | date }}</span>
      </div>
      <div class="card-cell" [ngClass]="{ 'card-cell--full': basic }">
        <label>{{ "report.item.reportStatus" | translate }}</label>
        <span>{{ item?.reportStatus ? ("report.status." + item.reportStatus | translate) : "" }}</span>
        @if (item?.documents?.length || item?.hasDocuments) {
          <span class="paperclip icon-attach"></span>
        }
      </div>
      @if (!basic) {
        <div class="card-cell">
          @if (IS_TRS_PROJECT) {
            <label>{{ "report.item.signedBySpecialistShort" | translate }}</label>
            <span>{{ (item?.specialistSignature?.length ? specialistSigners || "generic.truthy.true" : "generic.truthy.false") | translate }}</span>
          } @else if (IS_PRODUCT_SAFETY_PROJECT) {
            <label>{{ "report.item.signedBySpecialist" | translate }}</label>
            <span>{{ (item?.specialistSignature ? item?.specialistSignature?.fullName || "generic.truthy.true" : "generic.truthy.false") | translate }}</span>
          }
        </div>
        <div class="card-cell">
          <label>{{ "report.item.signedByResponsible" | translate }}</label>
          <span class="one-liner">
            {{ (item?.responsibleSignature ? item?.responsibleSignature?.fullName || "generic.truthy.true" : "generic.truthy.false") | translate }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
